import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import InputText from "../../atoms/InputText/InputText";
import { QuestionProps } from "../../../types/components/molecules/questionProps";

const Seconde = ({ formData, setFormData, onValidationChange }: QuestionProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    onValidationChange?.(!!formData.name && formData.name !== "");
  }, [formData.name, onValidationChange]);

  return (
    <InputText
      label={t("animalInfo:QUESTION_TWO.NAME")}
      value={formData.name ?? ""}
      onChange={(value) => setFormData({ ...formData, name: value })}
    />
  );
};

export default Seconde;
